import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export const addSharing = async (payload: any): Promise<any> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/sharing`,
    {
      body: payload,
    }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

interface ISaveSearchOutput extends Types.ResponseOutput {
  data: { guid: string };
}
export const saveSearchByGuid = async (
  guid: string,
  name: string
): Promise<ISaveSearchOutput> => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/sharing/${guid}/save-search`,
    { body: { name } }
  );

  const _data: ISaveSearchOutput['data'] = data.data;
  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export interface ISharingProductOutput extends Types.ResponseOutput {
  data: any;
}
export interface ISharingProductInput {
  name: string;
  sharingType: number;
}
export const addSharingProduct = async (
  payload: ISharingProductInput
): Promise<ISharingProductOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/sharing/product`,
    { body: payload }
  );

  const _data: ISharingProductOutput['data'] = data.data;
  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
export interface ISharingByClientProductInput {
  name: string;
  sharingType: number;
  customerId: number;
}
export const addSharingByClientProduct = async (
  payload: ISharingByClientProductInput
): Promise<ISharingProductOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/sharing/product-by-client`,
    { body: payload }
  );

  const _data: ISharingProductOutput['data'] = data.data;
  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
export interface ISharingListProductInput {
  ids: number[];
  sharingType: number;
}

export const sharingByListProduct = async (
  payload: ISharingListProductInput
): Promise<ISharingProductOutput> => {
  console.log('payload', payload);
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/sharing/by-products
    `,
    { body: payload }
  );

  const _data: ISharingProductOutput['data'] = data.data;
  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const sharingByTasks = async (
  payload: ISharingListProductInput
): Promise<ISharingProductOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/sharing/by-tasks
    `,
    { body: payload }
  );

  const _data: ISharingProductOutput['data'] = data.data;
  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const addSharingListProduct = async (
  payload: ISharingListProductInput
): Promise<ISharingProductOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/sharing/product
    `,
    { body: payload }
  );

  const _data: ISharingProductOutput['data'] = data.data;
  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface IFetchSaveSearchOutput extends Types.ResponseOutput {
  data: any;
}
export const getSavedSearchByClientId = async (
  clientid: number
): Promise<IFetchSaveSearchOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/sharing/${clientid}/save-search`
  );

  const _data = data.data;

  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const getClientRequestByClientId = async (
  clientid: number
): Promise<IFetchSaveSearchOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/sharing/${clientid}/client-request`
  );

  const _data = data.data;

  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export interface IAddClientRequestInput {
  guid: string;
  name: string;
  clientid: number;
}

export const addClientRequest = async (
  payload: IAddClientRequestInput
): Promise<IFetchSaveSearchOutput> => {
  const { guid, ...rest } = payload;
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/sharing/${guid}/client-request`,
    {
      body: {
        ...rest,
      },
    }
  );

  const _data = data.data;

  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const getCollectionByGuid = async (
  guid: string
): Promise<IFetchSaveSearchOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/sharing/${guid}/collection-detail`
  );

  const _data = data.data;

  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
